import {Component, OnDestroy, OnInit} from '@angular/core';
import {SEOService} from '../../shared/services/seo.service';
import {AppState} from '../../core/store/app.state';
import {Store} from '@ngrx/store';
import {setClassHeader} from '../../core/store/header/header.actions';
import {ModalService} from '../../shared/services/util/modal.service';
import {StateStorageService} from '../../shared/services/auth/state-storage.service';
import {Router} from '@angular/router';
import {AuthService} from '../../shared/services/auth/auth.service';
import {User} from '../../core/model/user/user.model';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {IListRecipe} from '../../core/model/recipe/list-recipe.model';
import {RecipeService} from '../../shared/services/recipe/recipe.service';
import {FilterRecipe} from '../../core/model/recipe/filter-recipe.model';
import {STATE_LIST_BLOGS_HOME, STATE_LIST_RECIPES_HOME, STATE_LIST_USERS_HOME} from '../../core/transfert-state/state';
import {UtilsTransfertsState} from '../../shared/services/util/utils-transferts-state';
import {BlogService} from '../../shared/services/blog/blog.service';
import {FilterBlog} from '../../core/model/blog/filter-blog.model';
import {IListBlog} from '../../core/model/blog/list-blog.model';
import {SsrContext} from '../../shared/services/util/ssr-context.service';
import {IListUser} from '../../core/model/user/list-user.model';
import {UserService} from '../../shared/services/user/user.service';
import {FilterUser} from '../../core/model/user/filter-user.model';

@Component({
    selector: 'app-home-container',
    templateUrl: './home-container.component.html',
    styleUrls: ['./home-container.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any>;

  user: User;
  recipesCosmetics: IListRecipe[];
  recipesEntretiens: IListRecipe[];
  blogs: IListBlog[] = [];
  users: IListUser[] = [];
  classNews = '';

  constructor(private seoService: SEOService,
              private modalService: ModalService,
              private stateStorageService: StateStorageService,
              private router: Router,
              private authService: AuthService,
              private recipeService: RecipeService,
              private blogService: BlogService,
              private userService: UserService,
              private utilsTransfertsState: UtilsTransfertsState,
              private ssrContext: SsrContext,
              private store: Store<AppState>) {
    this.user = this.authService.userIdentity();
    this._unsubscribeAll = new Subject();
    this.seoService.updatePageSEO('Tooda - Découvre & crée tes propres recettes fait maison', 'La plateforme communautaire du fait maison - Découvre et crée des recettes fait maison, partage ton savoir-faire, interagis avec la communauté et trouve l\'inspiration pour tes projets DIY.', 'Accueil');

    const filterRecipe = new FilterRecipe();
    filterRecipe.size = 6;
    filterRecipe.page = 0;
    filterRecipe.isHome = true;

    this.utilsTransfertsState
      .getStateOrQuery(STATE_LIST_RECIPES_HOME, this.recipeService.query(filterRecipe))
      .subscribe(recipesCosmetics => {
        this.recipesCosmetics = recipesCosmetics.content.filter(recipe => recipe.domainTitle === 'cosmetique');
        this.recipesEntretiens = recipesCosmetics.content.filter(recipe => recipe.domainTitle === 'entretien');
      });

    const filterBlog = new FilterBlog();
    filterBlog.size = 6;
    filterBlog.page = 0;
    filterBlog.isHome = true;

    this.utilsTransfertsState
      .getStateOrQuery(STATE_LIST_BLOGS_HOME, this.blogService.query(filterBlog))
      .subscribe(blogs => {
        this.blogs = blogs.content;
      });

    const filterUser = new FilterUser();
    filterUser.size = 6;
    filterUser.page = 0;
    filterUser.isHome = true;

    this.utilsTransfertsState
      .getStateOrQuery(STATE_LIST_USERS_HOME, this.userService.query(filterBlog))
      .subscribe(users => {
        this.users = users.content;
      });
  }

  ngOnInit(): void {
    if (!this.ssrContext.isServer()) {
      setTimeout(() => {
        this.classNews = 'hide-text-news';
      }, 2500);
    }

    this.authService.getUserState()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (user) => {
          this.user = user;
        },
        error: (err) => {
          console.error(err);
        }
      });

    this.store.dispatch(setClassHeader({classHeader: 'transparency input-white'}));
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next({});
    this._unsubscribeAll.complete();
    this.store.dispatch(setClassHeader({classHeader: ''}));
  }

  scrollToElement($element: HTMLHeadingElement): void {
    const y = $element.offsetTop;
    window.scrollTo({top: y, behavior: 'smooth'});
  }


  openModal(id: string): void {
    this.modalService.open(id);
  }

  closeModal(id: string): void {
    this.modalService.close(id);
  }

  closeModalLogin(id: string): void {
    this.closeModal(id);
    this.stateStorageService.storeUrl(this.router.url);
  }

  removeClass(event: HTMLButtonElement): void {
    event.className = '';
  }
}
